var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"iframe",attrs:{"src":_vm.iframeSrc}})
}
var staticRenderFns = []

export { render, staticRenderFns }